export enum Servers {
  layoutCreator = 'layoutCreator',
  gradoo = 'gradoo'
}

export type GradooTokens = {
  token: string
  refreshToken: string
}
